<template>
  <section class="relative overflow-hidden bg-black font-ww-medium">
    <div>
      <nuxt-img
          class="lg:relative absolute"
          width="1920"
          height="974"
          loading="lazy"
          format="webp"
          :alt="backgroundImageAlt"
          sizes="xs:320px sm:420px md:768px lg:1024px xl:1200px 2xl:1920px"
          :src="backgroundImageSrc"
      />
    </div>

    <div class="relative lg:absolute inset-0 m-auto max-w-screen-2xl px-5 md:px-7 lg:px-14 xl:px-20 2xl:px-12 py-10 lg:py-5 flex items-center">
      <div class="w-full text-center font-ww-medium">
        <h2 class="h1 uppercase text-white text-3xl lg:text-6xl font-extrabold" v-html="mainTextLine1"></h2>
        <h2 class="h1 uppercase text-white text-6xl lg:text-9xl xl:text-9xl font-extrabold tracking-wide" v-html="mainTextLine2"></h2>
        <h2 class="h1 uppercase text-white text-3xl lg:text-6xl mt-2 font-extrabold" v-html="mainTextLine3"></h2>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  backgroundImageSrc: {
    type: String,
    default: '/assets/images/bnr-2_1944x.jpg'
  },
  backgroundImageAlt: {
    type: String,
    default: 'Tested for Over'
  },
  mainTextLine1: {
    type: String,
    default: 'Tested for Over'
  },
  mainTextLine2: {
    type: String,
    default: '400'
  },
  mainTextLine3: {
    type: String,
    default: 'Toxins'
  }
});

defineBuilderComponent({
    friendlyName: "Background Image Text",
    inputs: [
        {
            name: "backgroundImageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/bnr-2_1944x.jpg",
            required: true
        },
        {
            name: "backgroundImageAlt",
            type: "text",
            defaultValue: "Tested for Over"
        },
        {
            name: "mainTextLine1",
            type: "richText",
            defaultValue: "Tested for Over"
        },
        {
            name: "mainTextLine2",
            type: "richText",
            defaultValue: "400"
        },
        {
            name: "mainTextLine3",
            type: "richText",
            defaultValue: "Toxins"
        }
    ]
});
</script>